// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriberV3ClientGeneratedPrescriberLicenseType } from './prescriberV3ClientGeneratedPrescriberLicenseType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PrescriberV3ClientGeneratedPrescriberLicenseUpsearchModel {
    'prescriberLicenseId'?: number | null;
    'licenseType'?: PrescriberV3ClientGeneratedPrescriberLicenseType;
    'licenseNumber'?: string | null;
    'licenseStateCd': string;
    'licenseExpirationDt'?: Moment | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PrescriberV3ClientGeneratedPrescriberLicenseUpsearchModel>> = [
        {
            "name":     "prescriberLicenseId",
            "baseName": "prescriberLicenseId",
            "type":     "number"
        },
        {
            "name":     "licenseType",
            "baseName": "licenseType",
            "type":     "PrescriberV3ClientGeneratedPrescriberLicenseType"
        },
        {
            "name":     "licenseNumber",
            "baseName": "licenseNumber",
            "type":     "string"
        },
        {
            "name":     "licenseStateCd",
            "baseName": "licenseStateCd",
            "type":     "string"
        },
        {
            "name":     "licenseExpirationDt",
            "baseName": "licenseExpirationDt",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return PrescriberV3ClientGeneratedPrescriberLicenseUpsearchModel.attributeTypeMap;
    }
}
